RivalIQ.apps.Discovery.module('curations', function (curations, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const instagramDiscoveryWidgets = [
        {
            instanceId: 'discovery_at_a_glance',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_GLANCE,
            region: 'top',
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel']
            }
        },
        {
            instanceId: 'discovery_coincident_hashtags',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_SUMMARY_TABLE,
            region: 'insta-middle-left',
            title: 'Coincident Hashtags in Caption',
            description: RivalIQ.strings.discovery_instagram_coincident_hashtags_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'hashtag']
            },
            metrics: [{
                property: 'name',
                name: 'Hashtag',
                cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
            }, {
                property: 'num_posts'
            }, {
                property: 'engagement_total_per_post',
                cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                    color: RivalIQ.enums.colors.progressBarBlue
                }))
            }]
        },
        {
            instanceId: 'discovery_post_types',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_PIE_TABLE,
            region: 'insta-middle-right',
            title: 'Post Types',
            description: RivalIQ.strings.discovery_post_types_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'postType']
            },
            metrics: [{
                property: 'name',
                valueFormat: _.upperFirst,
                name: 'Type',
                cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
            }, {
                property: 'num_posts'
            }, {
                property: 'engagement_total_per_post',
                cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                    color: RivalIQ.enums.colors.progressBarBlue
                }))
            }]
        },
        {
            instanceId: 'discovery_common_terms',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_DIMENSION_ANALYSIS,
            region: 'insta-bottom',
            title: 'Common Phrases',
            description: RivalIQ.strings.discovery_common_phrases_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'frequentTerm']
            },
            metrics: [{
                property: 'name',
                name: 'Term',
                valueFormat: _.identity,
                cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
            }, {
                property: 'num_posts'
            }, {
                property: 'engagement_total_per_post',
                cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                    color: RivalIQ.enums.colors.progressBarBlue
                }))
            }]
        },
        {
            instanceId: 'discovery_posts_table',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_POST_TABLE,
            region: 'insta-bottom',
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'postId']
            },
            props: {
                limit: 8,
                orderBy: 2,
                layout: 'grid_square'
            }
        }
    ];

    const twitterDiscoveryWidgets = [
        {
            instanceId: 'discovery_at_a_glance',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_GLANCE,
            region: 'top',
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel']
            }
        },
        {
            instanceId: 'discovery_influencer_table',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_INFLUENCER_TABLE,
            region: 'top',
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'influencerId']
            }
        },
        {
            instanceId: 'discovery_coincident_hashtags',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_SUMMARY_TABLE,
            region: 'middle-left',
            title: 'Coincident Hashtags',
            description: RivalIQ.strings.discovery_coincident_hashtags_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'hashtag']
            },
            metrics: [
                {
                    property: 'name',
                    name: 'Hashtag',
                    cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
                },
                {
                    property: 'people_using',
                    hideWhenSinglePeopleUsing: true
                },
                {
                    property: 'num_posts',
                    focusOnly: true,
                    showWhenSinglePeopleUsing: true
                },
                {
                    property: 'average_sentiment',
                    description: RivalIQ.strings.discovery_average_sentiment_description,
                    focusOnly: true
                },
                {
                    property: 'median_user_followers',
                    focusOnly: true
                },
                {
                    property: 'engagement_total_per_post',
                    focusOnly: true
                },
                {
                    property: 'avg_engagement_rate_per_post',
                    cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                        color: RivalIQ.enums.colors.progressBarBlue
                    }))
                }
            ]
        },
        {
            instanceId: 'discovery_mentions',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_PIE_TABLE,
            region: 'middle-right',
            title: 'Mentions',
            description: RivalIQ.strings.discovery_coincident_mentions_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'mention']
            },
            metrics: [
                {
                    property: 'name',
                    name: 'Mention',
                    cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
                },
                {
                    property: 'people_using',
                    hideWhenSinglePeopleUsing: true
                },
                {
                    property: 'num_posts',
                    focusOnly: true,
                    showWhenSinglePeopleUsing: true
                },
                {
                    property: 'average_sentiment',
                    description: RivalIQ.strings.discovery_average_sentiment_description,
                    focusOnly: true
                },
                {
                    property: 'median_user_followers',
                    focusOnly: true
                },
                {
                    property: 'engagement_total_per_post',
                    focusOnly: true
                },
                {
                    property: 'avg_engagement_rate_per_post',
                    cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                        color: RivalIQ.enums.colors.progressBarBlue
                    }))
                }
            ]
        },
        {
            instanceId: 'discovery_common_terms',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_DIMENSION_ANALYSIS,
            region: 'bottom-left',
            title: 'Common Phrases',
            description: RivalIQ.strings.discovery_common_phrases_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'frequentTerm']
            },
            metrics: [
                {
                    property: 'name',
                    name: 'Term',
                    valueFormat: _.identity,
                    cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
                },
                {
                    property: 'people_using',
                    hideWhenSinglePeopleUsing: true
                },
                {
                    property: 'num_posts',
                    focusOnly: true,
                    showWhenSinglePeopleUsing: true
                },
                {
                    property: 'average_sentiment',
                    description: RivalIQ.strings.discovery_average_sentiment_description,
                    focusOnly: true
                },
                {
                    property: 'median_user_followers',
                    focusOnly: true
                },
                {
                    property: 'engagement_total_per_post',
                    focusOnly: true
                },
                {
                    property: 'avg_engagement_rate_per_post',
                    cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                        color: RivalIQ.enums.colors.progressBarBlue
                    }))
                }
            ]
        },
        {
            instanceId: 'discovery_bios_common_terms',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_DIMENSION_ANALYSIS,
            region: 'bottom-right',
            title: 'Common Terms in Bios',
            description: RivalIQ.strings.discovery_bios_common_terms_description,
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'influencerBioTerm'],
                minPeopleUsing: 3
            },
            metrics: [
                {
                    property: 'name',
                    name: 'Term',
                    valueFormat: _.identity,
                    cellView: _.constant(RivalIQ.apps.Discovery.views.DimensionAnalysisNameCell)
                },
                {
                    property: 'people_using',
                    hideWhenSinglePeopleUsing: true
                },
                {
                    property: 'num_posts',
                    focusOnly: true,
                    showWhenSinglePeopleUsing: true
                },
                {
                    property: 'median_user_followers',
                    focusOnly: true
                },
                {
                    property: 'engagement_total_per_post',
                    focusOnly: true
                },
                {
                    property: 'avg_engagement_rate_per_post',
                    cellView: _.constant(RivalIQ.views.metric.Bar.extend({
                        color: RivalIQ.enums.colors.progressBarBlue
                    }))
                }
            ]
        },
        {
            instanceId: 'discovery_posts_table',
            widgetId: RivalIQ.enums.widgetTypes.DISCOVERY_POST_TABLE,
            region: 'bottom',
            baseMetric: {
                dataSource: 'discovery',
                dimensions: ['channel', 'postId']
            },
            props: {
                limit: 8
            }
        }
    ];

    const config = [
        // all channels use this
        {
            name: 'top',
            sizes: {
                md: 12
            },
            page: 0
        },
        // twitter uses these
        [
            {
                name: 'middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            },
            {
                name: 'middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 1
            }
        ],
        [
            {
                name: 'bottom-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            },
            {
                name: 'bottom-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 2
            }
        ],
        {
            name: 'bottom',
            sizes: {
                md: 12
            },
            page: 3
        },
        // instagram uses this
        [
            {
                name: 'insta-middle-left',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            },
            {
                name: 'insta-middle-right',
                className: 'x-normalize-heights',
                sizes: {
                    md: 6,
                    sm: 12,
                    'sm-export': 6
                },
                page: 0
            }
        ],
        {
            name: 'insta-bottom',
            sizes: {
                md: 12
            },
            page: 2
        }
    ];

    const DiscoveryLayoutMixin = {

        dashboardModelEvents: {
            'change': 'reload'
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            const metric = RivalIQ.metric.build(props, _.defaults({
                dimensions: ['channel'],
                property: 'num_posts'
            }, me.dashboardModel.baseMetric), {
                clobberDimensions: true
            });

            const metricDef = new RivalIQ.models.MetricDefinition(metric);

            // We always want the loadData to succeed even it we encounter an error; that way, we can still
            // take advantage of the success layout (with search bar) in error cases.
            const deferred = new $.Deferred();

            metricDef.fetch()
                .then(function (results) {
                    me.hadNoResults = results.getValue({
                        format: false
                    }) === 0;
                    // reset to ignore any previous error
                    me.errorName = null;
                }).fail(function (xhr) {
                    me.hadNoResults = null;
                    me.errorName = _.get(xhr, 'errorName', xhr.status);
                }).always(deferred.resolve);

            return deferred;
        },

        getTemplateforError: function (errorName) {
            const me = this;

            let template;
            if (errorName === 'UnknownHandleError') {
                template = '#discoveryUsernameNotFoundTemplate';
            } else if (errorName === 'PresenceLikelyInvalidError' && me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                template = '#discoveryInstagramNotABusinessAccountTemplate';
            } else if (errorName === 'BadSearchSyntaxError') {
                template = `#discovery${s.titleize(me.getProp('channel'))}BadSearchSyntaxTemplate`;
            } else if (errorName === 'ExceededRateLimitError') {
                template = `#discovery${s.titleize(me.getProp('channel'))}RateLimitExceededErrorTemplate`;
            } else if (errorName === 'OauthInvalidError') {
                template = `#discovery${s.titleize(me.getProp('channel'))}OauthInvalidErrorErrorTemplate`;
            } else if ((errorName === 'InvalidHashtagError') || (errorName === 'FacebookCouldNotFindHashtagError')) {
                template = '#discoveryInstagramInvalidHashtagErrorTemplate';
            } else if (errorName === 'FacebookHashtagSearchLimitExceeded') {
                template = '#discoveryInstagramHashtagSearchLimitExceededErrorTemplate';
            } else if (errorName === 'TwitterSearchParameterTooLongError') {
                template = '#discoveryTwitterSearchParameterTooLongTemplate';
            } else {
                template = '#widgetErrorView';
            }

            return template;
        },

        showErrorMessage: function () {
            const me = this;

            const template = me.getTemplateforError(me.errorName);

            new RivalIQ.views.ItemView({
                template: template,
                el: me.ui.noResults
            }).render();
            me.ui.noResults.show();
        }
    };

    const DiscoveryLayout = Dashboard.views.CurationLayout.mixin({
        config: config,

        LoadingView: App.views.DiscoveryLoadingView,

        className: 'flex-toolbar-layout',

        template: '#discoveryCurationLayoutTemplate',

        ui: {
            noResults: '.no-results',
            widgets: '.dashboard-regions'
        },

        mixins: {
            DiscoveryLayoutMixin: DiscoveryLayoutMixin
        },

        // the base CurationLayout shows toolbars on render loaded, but we need to show them here
        // as the searchBar loads data and we want those metric requests to happen in the same http
        // request as the widgets on the page.
        onRender: function () {
            const me = this;
            me.showToolbars();
        },

        onRenderLoaded: function () {
            const me = this;
            me.toggleView();
        },

        refresh: function () {
            const me = this;
            me.toggleView();
        },

        toggleView: function () {
            const me = this;

            me.requestRenderedFrame(function () {
                if (me.errorName) {
                    me.ui.widgets.hide();
                    me.showErrorMessage();
                } else if (me.hadNoResults) {
                    me.ui.noResults.show();
                    me.ui.widgets.hide();
                } else {
                    me.ui.noResults.hide();
                    me.ui.widgets.show();
                }
            });
        },

        showLeftToolbarActions: function () {
            const me = this;

            me.showBackLink();

            me.leftActions.show(new App.views.SearchBar({
                dashboardModel: me.dashboardModel
            }), {
                preventDestroy: true
            });
        },

        showBackLink: function () {
            const me = this;

            me.leftActions.show(new RivalIQ.views.Link({
                className: 'btn btn-default btn-back-link discovery-back-btn',
                linkName: '<span class="fa fa-chevron-left"></span>',
                attributes: _.constant({
                    href: me.dashboardModel.getBackToSearchPath()
                })
            }), {
                preventDestroy: true
            });
        },

        serializeData: function () {
            const me = this;

            const channel = me.getProp('channel');
            const postWord = RivalIQ.data.channels.get(channel).get('postName');

            return {
                postWord: postWord
            };
        }
    });

    const DiscoveryDetailsLayout = Dashboard.views.DetailsLayout.mixin({
        className: 'flex-toolbar-layout details',

        mixins: {
            DiscoveryLayoutMixin: DiscoveryLayoutMixin
        },

        template: '#discoveryWidgetDetailLayoutTemplate',

        ui: {
            noResults: '.no-results'
        },

        // As this is a loading view, the dom won't be setup yet; we need to show the toolbar views
        // in onRenderLoaded instead.
        onBeforeShow: _.noop,

        onRenderLoaded: function () {
            const me = this;

            me.showLeftToolbarActions();
            me.showToolbarActions();

            if (me.errorName) {
                if (me.ui.widgets) {
                    me.ui.widgets.hide();
                }

                me.showErrorMessage();
            } else if (me.hadNoResults) {
                me.requestRenderedFrame(function () {
                    me.ui.noResults.show();

                    if (me.body.$el) {
                        me.body.$el.hide();
                    }
                });
            } else {
                RivalIQ.apps.Dashboard.utils.execWithBuffering(function () {
                    const View = me.getBodyView();
                    me.body.show(new View({
                        dashboardModel: me.dashboardModel
                    }));
                });
            }
        },

        showLeftToolbarActions: function () {
            const me = this;

            me.showBackLink();

            const navToolbar = new App.views.SearchBar({
                dashboardModel: me.dashboardModel
            });

            // the preventDestroy is needed so we don't clear out the backlink
            me.leftActions.show(navToolbar, {
                preventDestroy: true
            });
        }
    });

    const ExportLayout = Dashboard.views.ExportWidgets.extend({
        childView: Dashboard.views.ExportLayout.extend({
            config: config
        })
    });

    const CURATION_FILTER_CONFIGURATIONS = _.map(App.utils.WIDGET_FILTER_CONFIGURATIONS, function (config) {
        return _.defaults({
            nameTransform: s.titleize,
            valueTransform: function (s) {
                let result = s;

                if (config.valueTransform) {
                    result = config.valueTransform(s);
                }

                return _.escape(result);
            }
        }, config);
    });

    curations.DiscoveryCuration = Dashboard.models.Curation.mixin({
        mixins: {
            ExportHD: RivalIQ.apps.Dashboard.mixins.ExportHD,
            CurationBufferedEventProxy: Dashboard.mixins.CurationBufferedEventProxy
        },

        beforeFilters: [
            curations.filters.ensureChannelToken,

            // ensureChannelToken might change the handle, so need to reset the title
            RivalIQ.apps.Dashboard.curations.filters.updateShell
        ],

        buildConfiguration: function () {
            const me = this;

            // set timePeriodType here in the curation config so it doesn't end up as a query param
            const configuration = RivalIQ.apps.Dashboard.models.Curation.prototype.buildConfiguration.call(me);
            configuration.set('props', {
                timePeriodType: RivalIQ.state.timePeriods.types.TODAY
            });

            return configuration;
        },

        widgetsView: function () {
            const me = this;

            if (me.getProp('searchTerm')) {
                return DiscoveryLayout;
            } else {
                return App.views.InitialSearchBar;
            }
        },
        widgetView: DiscoveryDetailsLayout,
        exportWidgetsView: ExportLayout,

        widgetDefinitions: function () {
            const me = this;

            let widgets = [];

            if (me.getProp('searchTerm')) {

                switch (me.getProp('channel')) {
                    case RivalIQ.enums.channels.TWITTER:
                        widgets = twitterDiscoveryWidgets;
                        break;

                    case RivalIQ.enums.channels.INSTAGRAM:
                        widgets = instagramDiscoveryWidgets;
                        break;

                    default:
                        widgets = [];
                }
            }

            return widgets;
        },

        processProps: function (props) {

            if (props.channel === RivalIQ.enums.channels.INSTAGRAM) {
                delete props.followerCountLow;
                delete props.followerCountHigh;
            }

            return props;
        },

        dataFreshness: false,
        companySets: false,
        timePeriod: RivalIQ.enums.timePeriod.type.NOT_AVAILABLE,

        baseMetric: {
            dataSource: 'discovery',
            dimensions: ['channel']
        },

        getBackToSearchPath: function () {
            const me = this;
            const curationRouteOptions = {
                channel: me.getProp('channel')
            };

            if (me.getProp('channel') === RivalIQ.enums.channels.INSTAGRAM) {
                curationRouteOptions.searchType = me.getProp('searchType') || 'recent';
            }

            return me.router.resolveCurationRoute(me.id, curationRouteOptions);
        },

        getBackPath: function (widgetProps) {
            const me = this;
            const props = _.pick(widgetProps, App.utils.validCurationOptions);
            const path = me.getBasePath(props);
            return path;
        },

        getBasePath: function (overrides) {
            const me = this;
            const postsWidget = me.getWidget('discovery_posts_table');

            const props = _.extend({
                channel: me.getProp('channel')
            }, overrides);

            // don't let this be overridden
            props.postsWidgetLayout = postsWidget ? postsWidget.getProp('layout') : me.getProp('postsWidgetLayout');

            return me.router.resolveCurationRoute(me.id, props);
        },

        getTitle: function () {
            const me = this;

            return RivalIQ.strings[`discovery_${me.getProp('channel')}_app_title`];
        },

        getFilename: _.partial(App.utils.getExportFilename, false),

        getExportTitle: function () {
            const me = this;
            return me.getTitle();
        },

        getExportSubtitle: function () {
            const me = this;
            const props = me.getProps();
            return App.utils.constructAppliedFilters(CURATION_FILTER_CONFIGURATIONS, props);
        },

        getBackLinkName: _.constant(),
        getBackLinkClassName: _.constant('btn btn-default btn-back-link')
    });

}, window.s);
